'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$() {
  this.aKj = null;
  this.aKA = null;
  this.aKm = null;
  this.aKn = false;
  this.aKs = null;
  this.aKt = false;
  this.aKy = null;
  this.aKz = false;
  this.aKk = null;
  this.aKl = false;
  this.aKw = null;
  this.aKx = false;
  this.aKu = null;
  this.aKv = false;
  this.aKo = null;
  this.aKp = false;
  this.aKq = null;
  this.aKr = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ = this;
  this.aKj = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$();
  this.aKA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aKj;
});
$p.eO = (function() {
  return this.aKA;
});
$p.bW = (function() {
  if ((!this.aKn)) {
    this.aKm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aKn = true;
  }
  return this.aKm;
});
$p.b9 = (function() {
  if ((!this.aKt)) {
    this.aKs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aKt = true;
  }
  return this.aKs;
});
$p.b3 = (function() {
  if ((!this.aKz)) {
    this.aKy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aKz = true;
  }
  return this.aKy;
});
$p.aG = (function() {
  if ((!this.aKl)) {
    this.aKk = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aKl = true;
  }
  return this.aKk;
});
$p.az = (function() {
  if ((!this.aKx)) {
    this.aKw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aKx = true;
  }
  return this.aKw;
});
$p.aY = (function() {
  if ((!this.aKv)) {
    this.aKu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aKv = true;
  }
  return this.aKu;
});
$p.Je = (function() {
  if ((!this.aKp)) {
    this.aKo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Importer";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aKp = true;
  }
  return this.aKo;
});
$p.bsi = (function() {
  if ((!this.aKr)) {
    this.aKq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aKr = true;
  }
  return this.aKq;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$, "app.data.data_point_types$package$ImporterNameForm$", ({
  FP: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$() {
  this.aKh = null;
  this.aKi = false;
  this.aKf = null;
  this.aKg = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aKi)) {
    this.aKh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aKi = true;
  }
  return this.aKh;
});
$p.brZ = (function() {
  if ((!this.aKg)) {
    this.aKf = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$().Je();
    this.aKg = true;
  }
  return this.aKf;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$, "app.data.data_point_types$package$ImporterName$", ({
  FO: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterName$ };
//# sourceMappingURL=app.data.data_point_types$package$-Importer-Name$.js.map
